<template>
  <div class="page-content">
    <div class="content">
      <h1 class="page-title">{{ $t('token.title') }}</h1>
      <div class="intro-section">
        <img
          src="../assets/img/pingtaitongzheng.png"
          alt="通证经济模型"
          class="section-image"
        />
        <img
          src="../assets/img/jingjifenpei.png"
          alt="经济分配机制"
          class="section-image"
          style="margin-top: 20px"
        />
        <div class="article">
          <p>{{ $t('token.intro') }}</p>

          <div class="token-details">
            <h3>{{ $t('token.details1.title') }}</h3>
            <ul>
              <li>{{ $t('token.details1.name') }}</li>
              <li>{{ $t('token.details1.symbol') }}</li>
              <li>{{ $t('token.details1.supply') }}</li>
            </ul>
          </div>

          <div class="token-details">
            <h3>{{ $t('token.details2.title') }}</h3>
            <ul>
              <li>{{ $t('token.details2.mechanism1') }}</li>
              <li>{{ $t('token.details2.mechanism2') }}</li>
              <li>{{ $t('token.details2.mechanism3') }}</li>
            </ul>
          </div>

          <div class="token-details">
            <h3>{{ $t('token.details3.title') }}</h3>
            <p>{{ $t('token.details3.content') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Token',
  mounted() {
    // 监听语言切换事件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    this.$root.$off('language-changed');
  },
};
</script>

<style scoped>
.page-content {
  min-height: calc(100vh - 160px);
  width: 100%;
  padding: 0;
  background: var(--bg-primary);
}

.content {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 30px 15px;
  background: var(--bg-primary);
}

.page-title {
  font-size: 42px;
  line-height: 56px;
  font-weight: 700;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom: 3px solid var(--accent-primary);
}

.intro-section {
  margin-top: 30px;
}

.section-image {
  width: 100%;
  max-width: 100%;
  display: block;
  margin: 0 auto 40px;
}

.article {
  font-size: 18px;
  line-height: 36px;
  color: var(--text-secondary);
  text-align: justify;
  padding: 0 10px 30px;
  width: 100%;
}

.article p {
  margin-bottom: 20px;
}

.token-details {
  margin: 40px 0;
  padding: 30px;
  background: var(--bg-card);
  border-radius: 8px;
  border-left: 4px solid var(--accent-primary);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.token-details:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
  background: var(--bg-card-hover);
}

.token-details h3 {
  font-size: 26px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 20px;
}

.token-details ul {
  list-style-type: disc;
  padding-left: 25px;
  margin-top: 10px;
}

.token-details ul li {
  margin-bottom: 12px;
  line-height: 28px;
  color: var(--text-secondary);
}

@media (max-width: 768px) {
  .content {
    width: 100%;
    padding: 20px 15px;
  }

  .page-title {
    font-size: 28px;
    line-height: 36px;
  }

  .article {
    font-size: 16px;
    line-height: 28px;
    padding: 0 10px 20px;
  }

  .token-details {
    padding: 20px;
  }

  .token-details h3 {
    font-size: 20px;
  }
}
</style>
